import { CONFIG } from '../config.js';
import { centerOfMass } from './com.js';

export function computeAccelerations(list, config = CONFIG) {
  const G = config.G;
  const eps2 = config.EPSILON * config.EPSILON;

  for (let i = 0; i < list.length; i++) {
    list[i].accel.set(0, 0, 0);
  }

  for (let i = 0; i < list.length; i++) {
    for (let j = i + 1; j < list.length; j++) {
      const a = list[i];
      const b = list[j];
      const dx = b.position.x - a.position.x;
      const dy = b.position.y - a.position.y;
      const dz = b.position.z - a.position.z;
      const r2 = dx * dx + dy * dy + dz * dz + eps2;
      const invR = 1 / Math.sqrt(r2);
      const invR3 = invR * invR * invR;
      const fx = G * dx * invR3;
      const fy = G * dy * invR3;
      const fz = G * dz * invR3;
      a.accel.x += fx * b.mass;
      a.accel.y += fy * b.mass;
      a.accel.z += fz * b.mass;
      b.accel.x -= fx * a.mass;
      b.accel.y -= fy * a.mass;
      b.accel.z -= fz * a.mass;
    }
  }

  const R = centerOfMass(list);
  for (let i = 0; i < list.length; i++) {
    const body = list[i];
    const rx = body.position.x - R.x;
    const ry = body.position.y - R.y;
    const rz = body.position.z - R.z;
    const r = Math.sqrt(rx * rx + ry * ry + rz * rz);
    if (r > config.SOFT_RADIUS) {
      const over = r - config.SOFT_RADIUS;
      const scale = (-config.SOFT_K * over) / r;
      body.accel.x += scale * rx;
      body.accel.y += scale * ry;
      body.accel.z += scale * rz;
    }
  }
}
